import { gql } from '@apollo/client';

export const InviteGuestUsersToOrganization = gql`
  mutation InviteGuestUsersToOrganization(
    $organizationCode: String!
    $userEmails: [String!]!
    $invitationLanguage: String
  ) {
    inviteGuestUsersToOrganization(
      organizationCode: $organizationCode
      userEmails: $userEmails
      invitationLanguage: $invitationLanguage
    ) {
      error {
        code
        message
      }
      userEmail
      userImmutableId
    }
  }
`;
